import { TeacherPrivilegesAndSettingsDisplayItem } from '../api/TeacherPrivilegesAndSettingsDisplayItem';
import { TeacherPrivilegesAndSettingsUpdateItem } from '../api/TeacherPrivilegesAndSettingsUpdateItem';

declare module '../api/TeacherPrivilegesAndSettingsDisplayItem' {
    namespace TeacherPrivilegesAndSettingsDisplayItem {
        let ConvertToUpdateItem: typeof convertToUpdateItem;
    }
}

TeacherPrivilegesAndSettingsDisplayItem.ConvertToUpdateItem = convertToUpdateItem;

function convertToUpdateItem(displayItem: TeacherPrivilegesAndSettingsDisplayItem): TeacherPrivilegesAndSettingsUpdateItem {
    return new TeacherPrivilegesAndSettingsUpdateItem({
        CanEditExpensesAndRevenue: displayItem.CanEditExpensesAndRevenue,
        CanEditInvoicesAndAccounts: displayItem.CanEditInvoicesAndAccounts,
        CanEditMileage: displayItem.CanEditMileage,
        CanEditOtherTeacherSchedulesAndStudents: displayItem.CanEditOtherTeacherSchedulesAndStudents,
        CanEditOwnSchedule: displayItem.CanEditOwnSchedule,
        CanEditReports: displayItem.CanEditReports,
        CanEditSharedOnlineResources: displayItem.CanEditSharedOnlineResources,
        CanEditWebsiteAndPostNews: displayItem.CanEditWebsiteAndPostNews,
        CanRecordPaymentWithAttendance: displayItem.CanRecordPaymentWithAttendance,
        CanTakeAttendance: displayItem.CanTakeAttendance,
        CanViewOtherTeacherSchedules: displayItem.CanViewOtherTeacherSchedules,
        CanViewOtherTeacherContactInformation: displayItem.CanViewOtherTeacherContactInformation,
        CanViewOwnPayroll: displayItem.CanViewOwnPayroll,
        CanViewStudentAndParentAddressAndTelephone: displayItem.CanViewStudentAndParentAddressAndTelephone,
        CanViewStudentAndParentEmailAddresses: displayItem.CanViewStudentAndParentEmailAddresses,
        CanViewStudentAttachments: displayItem.CanViewStudentAttachments,
        IsActive: displayItem.IsActive,
        IsAdministrator: displayItem.IsAdministrator,
        IsTeacher: displayItem.IsTeacher
        // Do not copy optional properties
    });
}